import { useLayoutEffect, useEffect } from 'react';

/**
 * SSR friendly hack for using `useLayoutEffect`.
 * https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 *
 * To use:
 * import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect'
 */
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;